import cn from 'clsx'
import { rem } from 'polished'
import React, { ComponentProps, PropsWithChildren } from 'react'
import styled, { useTheme } from 'styled-components'

import SvgIcon, {
  SVG_ICON_SIZE_CSS_VAR,
  StyledSvgIcon,
} from 'components/Luxkit/SvgIcon'

export const TEARDROP_PIN_WIDTH = 30
export const TEARDROP_PIN_HEIGHT = 36

const StyledSvg = styled.svg`
  pointer-events: none;
  color: ${(props) => props.theme.palette.brand.primary.normal};
  overflow: visible;

  & > path {
    pointer-events: all;
    cursor: pointer;
  }

  &.isActive {
    color: ${(props) => props.theme.palette.highlight.secondary.normalForeground};
  }
`

const IconContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: ${rem(6)};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  > ${StyledSvgIcon} {
    ${SVG_ICON_SIZE_CSS_VAR}: 50%;
  }
`

const Container = styled.div`
  position: relative;
  width: auto;
  height: auto;
`

interface Props extends ComponentProps<typeof SvgIcon> {
  isActive?: boolean
}

function TeardropPin({ isActive, children }: PropsWithChildren<Props>) {
  const theme = useTheme()

  return (
    <Container>
      <StyledSvg
        className={cn({ isActive })}
        width={TEARDROP_PIN_WIDTH}
        height={TEARDROP_PIN_WIDTH}
        viewBox="0 0 24 30"
      >
        <path
          d="M20.9763 19.4042L20.3335 20.2149H20.3816L12.1218 29.4448C12.0559 29.5184 11.9442 29.5184 11.8782 29.4448L3.61843 20.2149H3.66649L3.02373 19.4042C1.44474 17.4128 0.5 14.8851 0.5 12.1322C0.5 5.70275 5.65388 0.5 12 0.5C18.3461 0.5 23.5 5.70275 23.5 12.1322C23.5 14.8851 22.5553 17.4128 20.9763 19.4042Z"
          fill="currentColor"
          stroke={theme.palette.neutral.default.eight}
        />
      </StyledSvg>
      <IconContainer>{children}</IconContainer>
    </Container>
  )
}

export default React.memo(TeardropPin)
